import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Settings, Workflow, Users, BarChart3, MessageSquare, CreditCard } from 'lucide-react';
import content from '../data/content.json';

const iconMap = {
  MessageSquare: MessageSquare,
  Users: Users,
  Settings: Settings,
  CreditCard: CreditCard,
  Workflow: Workflow,
  BarChart3: BarChart3
};

const Services = () => {
  const { hero, servicesSection, process, cta } = content.services;

  return (
    <div className="min-h-screen pt-20">
      {/* Hero Section */}
      <section className="pad-2xl">
        <div className="container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="heading-1 mb-6">
              {hero.title}
            </h1>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              {hero.subtitle}
            </p>
            <Link to="/free-audit" className="btn-orange">
              {hero.ctaText}
              <ArrowRight className="ml-2 h-5 w-5" />
            </Link>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="pad-2xl" style={{ background: 'var(--bg-section)' }}>
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-2 mb-4">{servicesSection.title}</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              {servicesSection.subtitle}
            </p>
          </div>
          
          <div className="ai-grid">
            {servicesSection.items.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              return (
                <div key={index} className="product-card">
                  <div className="mb-4">
                    <IconComponent className="h-10 w-10" style={{ color: 'var(--accent-text)' }} />
                  </div>
                  <h3 className="heading-3 mb-3">{service.title}</h3>
                  <p className="body-medium mb-4" style={{ color: 'var(--text-secondary)' }}>
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, idx) => (
                      <li key={idx} className="flex items-center body-small">
                        <div className="w-1.5 h-1.5 rounded-full mr-2" style={{ background: 'var(--accent-primary)' }}></div>
                        {feature}
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="pad-2xl">
        <div className="container">
          <div className="text-center mb-12">
            <h2 className="heading-2 mb-4">{process.title}</h2>
            <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
              {process.subtitle}
            </p>
          </div>
          
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              {process.steps.map((item, index) => (
                <div key={index} className="flex gap-4">
                  <div 
                    className="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center text-white font-bold"
                    style={{ background: 'var(--gradient-button)' }}
                  >
                    {item.step}
                  </div>
                  <div>
                    <h3 className="heading-3 mb-2">{item.title}</h3>
                    <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                      {item.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="pad-2xl" style={{ background: 'var(--bg-section)' }}>
        <div className="container">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="heading-2 mb-4">{cta.title}</h2>
            <p className="body-large mb-8" style={{ color: 'var(--text-secondary)' }}>
              {cta.subtitle}
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/free-audit" className="btn-orange">
                {cta.primaryCta}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Link>
              <Link to="/use-cases" className="btn-secondary">
                {cta.secondaryCta}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
